import { XMarkIcon } from '@heroicons/react/24/outline'
import { Button, Card, CardBody, Dialog, Input } from '@material-tailwind/react'
import React, { useState } from 'react'
import toast from 'react-hot-toast'
import { doc, updateDoc } from 'firebase/firestore'
import { db } from '../../firebase.config'
// update with your path

const ForwardNoModal = ({ handleForwardnoModal, forwardnoModal, setForwardnoModal, orderID, onSuccess, orderActivity }) => {
	// const [forwardNumber, setForwardNumber] = useState("")


	// const handleSubmit = async () => {
	// 	if (!forwardNumber) return toast.error("Please enter a forward number")
	// 	setLoading(true)
	// 	const date = new Date()
	// 	try {
	// 		const docRef = doc(db, "logisticOrder", orderID)
	// 		await updateDoc(docRef, {
	// 			forwardingNumber: forwardNumber,
	// 			orderStatus: "pickedUp",
	// 			orderActivity: [...orderActivity, {
	// 				status: "Picked Up",
	// 				remark: "Order has been Pickedup",
	// 				location: "GRC Bhiwandi",
	// 				time: date
	// 			}]
	// 		})

	// 		toast.success("Forward number saved")
	// 		window.location.reload()
	// 		setForwardnoModal(false)
	// 		setForwardNumber("")
	// 	} catch (err) {
	// 		console.error(err)
	// 		toast.error("Failed to update forward number")
	// 	} finally {
	// 		setLoading(false)
	// 	}
	// }
	// return (
	// 	<div>
	// 		<div>
	// 			<Dialog
	// 				size="xs"
	// 				open={forwardnoModal}
	// 				handler={handleForwardnoModal}
	// 				className="bg-transparent  shadow-none"
	// 			>
	// 				<Card className="lg:mx-auto relative w-full ">
	// 					<div className='px-6 pt-4 flex items-center justify-between' >
	// 						<div className='' >
	// 							<h3 className='text-[1.4rem] font-[GilroyBold]' >Enter Forwarding Number</h3>
	// 						</div>
	// 						<div onClick={() => setForwardnoModal(!forwardnoModal)} className=" cursor-pointer w-[40px] h-[40px]" >
	// 							<XMarkIcon className='w-[30px]' />
	// 						</div>
	// 					</div>
	// 					<CardBody className="h-[250px] mt-4 overflow-y-scroll ">
	// 						<div className='flex flex-col justify-center items-center gap-5'>
	// 							<Input
	// 								label="Forward Number"
	// 								value={forwardNumber}
	// 								onChange={(e) => setForwardNumber(e.target.value)}
	// 							/>
	// 							<Button onClick={handleSubmit} loading={loading} disabled={loading}>
	// 								{loading ? "Saving..." : "Save & Proceed"}
	// 							</Button>
	// 						</div>
	// 					</CardBody>

	// 				</Card>
	// 			</Dialog>
	// 		</div>
	// 	</div>
	// )
}

export default ForwardNoModal